(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["profile.htm"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"content result\">\r\n\t<div class=\"container\">\r\n\t\t<div class=\"row\">\r\n\t\t\t<div class=\"col-md-12 nopadding\">\r\n\t\t\t\t<h2 data-load-title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"loading")),"text"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domains_title"), env.opts.autoescape);
output += "</h2>\r\n\t\t\t\t<div class=\"col-md-3 domain-list\">\r\n\t\t\t\t\t<div data-domain-list>\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "domains");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("domain", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n\t\t\t\t\t\t\t<div class=\"domain_";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\" data-domain-cta=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t<div class=\"domain-name\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"progress\" data-width=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prc"), env.opts.autoescape);
output += "%\"></div>\r\n\t\t\t\t\t\t\t\t\t<div class=\"text\">\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"name\">\r\n\t\t\t\t\t\t\t\t\t\t\t<h6>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"nom"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prc"), env.opts.autoescape);
output += "%</h6>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"loading\">\r\n\t\t\t\t\t\t<span class=\"loading-dot\"></span>\r\n\t\t\t\t\t\t<span class=\"loading-dot\"></span>\r\n\t\t\t\t\t\t<span class=\"loading-dot\"></span>\r\n\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t<p class=\"note\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"footnote"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t<br>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"footnote2"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t</p>\r\n\r\n\t\t\t\t</div> <!--fin de la colonne des familles -->\r\n\r\n\t\t\t\t<div class=\"col-md-offset-1 col-md-8 nopadding\">\r\n\t\t\t\t\t<div class=\"light-box\" data-domain-desc>\r\n\t\t\t\t\t\t<!--{include:partials/domain}-->\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> <!--fin de la light-box -->\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div id=\"rollback-popup\" class=\"mfp-hide\">\r\n\t\t<h1>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"rollback")),"title"), env.opts.autoescape);
output += "</h1>\r\n\t\t<div class=\"instruction\">\r\n\t\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"rollback")),"message"), env.opts.autoescape);
output += "</p>\r\n\t\t</div>\r\n\t\t<button id=\"close-instructions\" class=\"btn btn-close\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"rollback")),"continue"), env.opts.autoescape);
output += "</button>\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
